import { render, staticRenderFns } from "./lectoParamsDown.vue?vue&type=template&id=75f10fda&scoped=true"
import script from "./lectoParamsDown.vue?vue&type=script&lang=js"
export * from "./lectoParamsDown.vue?vue&type=script&lang=js"
import style0 from "./lectoParamsDown.vue?vue&type=style&index=0&id=75f10fda&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f10fda",
  null
  
)

export default component.exports